import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { AuthService } from 'src/app/services/auth.service';
import { DatePipe } from '@angular/common';
import { AlertService } from '../../../services/alert.service';
import { RegisterType } from 'src/app/static/enums';

@Component({
  selector: 'app-letter-validation-card',
  templateUrl: './letter-validation-card.component.html',
  styleUrls: ['./letter-validation-card.component.scss'],
  providers: [DatePipe]
})
export class LetterValidationCardComponent implements OnInit {
  
  @Input() signature_url: string;
  @Input() current_first_transaction_date: string;
  @Input() mount: string='';
  @Input() bank: string='';
  @Input() total: string='';
  @Input() iva: string='';
  @Input() account_number: string='';
  @Input() comission: string='';
  @Input() percent: string='';
  employee: any;
  date:any
  dateText:any

constructor(public modalController : ModalController,private authService:AuthService,private alertService:AlertService) { 
    this.date = this.alertService.getCurrentDate()
    this.dateText=this.alertService.dateFormatText()
  }

  ngOnInit() {
    this.authService.user().subscribe(
      (data:any)=>{
        this.employee = data.high_employee;
        this.employee.name=data.high_employee.name+" "+data.high_employee.paternal_last_name+" "+data.high_employee.mother_last_name
      }
    );
  }

  closeModal(){
    this.modalController.dismiss();
  }

}
